import styled from 'styled-components';
import { darken } from 'polished';
import colors from '~/styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;
  flex: 1;
  justify-content: space-between;
  height: 20%;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
`;

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-around;
`;
export const StatusBadge = styled.span`
  padding: 0.2rem 1rem;
  border-radius: 4px;
  text-transform: capitalize;
  color: white !important;
  font-weight: bold !important;
  background-color: ${props => {
    switch (props.value) {
      case 'pending':
        return '#FFC105';
      case 'active':
        return '#28A744';
      case 'finished':
        return '#DC3445';
      default:
        return '#007BFF';
    }
  }};
`;

export const SubscriptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  ul {
    display: flex;
    flex-direction: column;
    flex: 1;
    li {
      font-size: 1.8rem;
      font-weight: bold;
    }
    li + li {
      margin-top: 1rem;
    }
    span {
      font-size: 1.6rem;
      color: ${colors.carbon};
      font-weight: 100;
    }
  }
  ul + ul {
    padding-left: 1.5rem;
    border-left: 1px solid #ddd;
  }
`;
export const ClientContainer = styled.ul`
  li {
    font-size: 1.8rem;
    font-weight: bold;
  }
  li + li {
    margin-top: 1rem;
  }
  span {
    font-size: 1.6rem;
    color: ${colors.carbon};
    font-weight: 100;
  }
  textarea {
    background: white;
    border: 1px;
    border-radius: 4px;
    height: 200px;
    padding: 20px;
    color: #000;
    margin: 0 0 10px;
    font-size: 18px;
    resize: none;

    &::placeholder {
      color: #999;
    }
  }
`;
export const NotesContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  textarea {
    flex: 1;
    display: flex;
    background: white;
    border: 0.5px solid #000;
    border-radius: 4px;
    height: 200px;
    padding: 5px;
    color: #000;
    font-size: 18px;
    resize: none;

    &::placeholder {
      color: #999;
    }
  }
  button {
    display: flex;
    border: 0;
    margin: 1rem;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    background-color: ${colors.primary};
    border-radius: 4px;
    padding: 0.5rem;
    transition: 1s background-color;
    &:hover {
      background-color: ${darken(0.2, colors.primary)};
    }
  }
`;
export const VehicleContainer = styled.div``;
export const PaymentsHeader = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  div {
    display: flex;
    flex-direction: row;
    h4 {
      margin-right: 1rem;
    }
    a {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 14px;
      background-color: ${darken(0.1, colors.primary)};
      border-radius: 4px;
      padding: 0.5rem;
      transition: 1s background-color;
      & + a {
        margin-left: 1rem;
      }
      &:hover {
        background-color: ${darken(0.2, colors.primary)};
      }
    }
  }
`;

export const PaymentsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const PaymentsInformation = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  h4 {
    color: #000;
    font-size: 22px;
  }
  margin-bottom: 1rem;
`;
export const PaymentsListContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;
export const PaymentList = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  & + & {
    margin-left: 1.5rem;
  }
`;
export const PaymentsListHeader = styled.div`
  background: #ddd;
  padding: 1.5rem;
  color: #000;
  font-weight: bold;
`;

export const ChargeContainer = styled.div`
  border: 1px solid #ddd;

  & + & {
    border-top: 1px solid #000;
    padding-top: 1rem;
    margin-top: 1rem;
  }
`;
export const ChargeContent = styled.div`
  color: white;
  background: ${props => {
    if (props.paid) {
      return 'rgba(127, 191, 63)';
    }
    if (props.remaining) {
      return 'rgba(222, 201, 6)';
    }
    if (props.pastDue) {
      return 'rgba(193, 66, 66)';
    }
    return '#007bff';
  }};
  padding: 1rem;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  p {
    width: 14rem;
  }
`;

export const Payments = styled.div`
  margin: 0px 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Payment = styled.div`
  padding: 1rem;
  margin: 0px 9rem;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  color: black;

  p {
    width: 22rem;
  }
  & + & {
    border-top: 1px solid #eeee;
  }
`;

export const ChargeActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  a {
    display: flex;
    width: 10rem;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    background-color: ${darken(0.1, colors.primary)};
    border-radius: 4px;
    padding: 0.5rem;
    transition: 1s background-color;
    & + a {
      margin-left: 1rem;
    }
    &:hover {
      background-color: ${darken(0.2, colors.primary)};
    }
  }
  a + button {
    margin-left: 1rem;
  }
  button {
    display: flex;
    width: 5rem;
    border: 0;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    background-color: #dc3445;
    border-radius: 4px;
    padding: 0.5rem;
    transition: 1s background-color;
    &:hover {
      background-color: ${darken(0.2, '#DC3445')};
    }
  }
`;

export const PaymentActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  a {
    color: ${darken(0.1, colors.primary)};
    transition: 1s background-color;
    & + a {
      margin-left: 1rem;
    }
    &:hover {
      color: ${darken(0.2, colors.primary)};
    }
  }
`;
